/**
 * IME candidate confirmation is delivered as a keyboard event before the
 * browser commits the composition text. Product shortcuts must leave that
 * event alone: preventing it or moving focus can commit the candidate twice.
 *
 * `keyCode === 229` covers WebKit/legacy IME events whose `isComposing` flag
 * is not exposed consistently.
 */
export function isImeCompositionEvent(event: KeyboardEvent): boolean {
	return event.isComposing || event.keyCode === 229;
}

/** A text-search shortcut may only run after the browser finishes composition. */
export function shouldCommitTextInputOnEnter(event: KeyboardEvent): boolean {
	return event.key === 'Enter' && !isImeCompositionEvent(event);
}
